import React from "react";
import { Input } from "@heroui/react";

type EmailProps = {
  setEmail: (email: string) => void;
  handleSubmit: () => void;
  value: string;
  isInvite?: boolean;
  ariaLabel?: string;
};
const Email: React.FC<EmailProps> = (props) => {
  return (
    <Input
      type="email"
      label="E-mailadres"
      onChange={(e) => props.setEmail(e.target.value)}
      onKeyDown={(e) => e.key == "Enter" && props.handleSubmit()}
      value={props.value}
      aria-label={props.ariaLabel}
      isDisabled={props.isInvite}
    />
  );
};

type PasswordProps = {
  label: string;
  setPassword: (email: string) => void;
  handleSubmit: () => void;
  value: string;
  ariaLabel?: string;
};
const Password: React.FC<PasswordProps> = (props) => {
  return (
    <Input
      type="password"
      label={props.label}
      onChange={(e) => props.setPassword(e.target.value)}
      onKeyDown={(e) => e.key == "Enter" && props.handleSubmit()}
      value={props.value}
      aria-label={props.ariaLabel}
    />
  );
};
type VerificationCodeProps = {
  setVerificationCode: (email: string) => void;
  handleSubmit: () => void;
  value: string;
  ariaLabel?: string;
};
const VerificationCode: React.FC<VerificationCodeProps> = (props) => {
  return (
    <Input
      label="Verificatiecode"
      onChange={(e) => props.setVerificationCode(e.target.value)}
      onKeyDown={(e) => e.key == "Enter" && props.handleSubmit()}
      value={props.value}
      aria-label={props.ariaLabel}
    />
  );
};

export { Email, Password, VerificationCode };
